module.exports = __webpack_public_path__ + "static/media/LogoMain.54327bec.png";